import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {
  public constructor(@Inject(LOCALE_ID) private locale: string) {}

  public transform(value?: number, fallback?: string): string | null {
    if (fallback && value == undefined) {
      return fallback;
    }
    const pipe = new DecimalPipe(this.locale);
    return pipe.transform(value, '1.0-2');
  }
}
